import { Domain } from 'effector'

import { ChatTag } from './types'

export const createUserEditorTagsModel = (userDomain: Domain) => {
  const { createEvent, createStore } = userDomain

  const setTags = createEvent<ChatTag[]>()
  const addTags = createEvent<ChatTag[]>()
  const removeTag = createEvent<number>()

  const $tags = createStore<ChatTag[]>([])
    .on(setTags, (_, tags) => tags.filter(Boolean))
    .on(addTags, (storedTags, addingTags) => {
      const newTags = addingTags.filter(Boolean).filter(
        (addingTag) =>
          !storedTags.some((storedTag) => {
            const exists = storedTag.id === addingTag.id
            const hasSameUser =
              'user' in storedTag &&
              'user' in addingTag &&
              storedTag.user?.id === addingTag.user?.id

            return exists || hasSameUser
          }),
      )

      return [...storedTags, ...newTags]
    })
    .on(removeTag, (tags, removingTagId) =>
      tags.filter((tag) => tag.id !== removingTagId),
    )

  return {
    events: {
      setTags,
      addTags,
      removeTag,
    },
    stores: {
      $tags,
    },
  }
}
